import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import PanelLayout from "../components/PanelLayout";
import ContextPropertyModifier from "../components/ContextPropertyInputPortList/ContextPropertyModifier";

class ContextUpdaterPanel extends Component {
    constructor(props) {
        super(props);

        this.hasFuncs = this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo;

        this.state = {
            func: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.func : {
                funcName: "concat",
                funcArgs: []
            },
            compositeFieldName: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.compositeFieldName : "",
            elementIdAutoIncrement: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.elementIdAutoIncrement : 0,
            shouldOverwriteContextPropertyIfExists: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.shouldOverwriteContextPropertyIfExists : true,
            shouldSuffixContextPropertyIfSplitIsUsed: this.hasFuncs ? this.props.clickedNodeInfo.extras.options.contextPropertyModifierInfo.shouldSuffixContextPropertyIfSplitIsUsed : false
        };

        this.updateProperty = this.updateProperty.bind(this);
    }

    updateOptions(func) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let contextPropertyModifierInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(contextPropertyModifierInfo.extras, "options")) {
            contextPropertyModifierInfo.extras.options = {};
        }
        contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo = {
            ...this.state,
            func
        }

        this.setState({
            func: func
        });

        this.props.clickedNodeAction(contextPropertyModifierInfo);
    }

    updateProperty(property, value) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let contextPropertyModifierInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(contextPropertyModifierInfo.extras, "options")) {
            contextPropertyModifierInfo.extras.options = {};
        }
        const func = contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo && contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.func ?
            contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo.func : this.state.func;
        contextPropertyModifierInfo.extras.options.contextPropertyModifierInfo = {
            ...this.state,
            [property]: value,
            func
        }

        this.setState({
            [property]: value
        });

        this.props.clickedNodeAction(contextPropertyModifierInfo);
    }

    render() {
        return (
            <PanelLayout>
                <ContextPropertyModifier
                    updateOptions={(funcName) => this.updateOptions(funcName)}
                    func={this.state.func}
                    compositeFieldName={this.state.compositeFieldName}
                    shouldOverwriteContextPropertyIfExists = {this.state.shouldOverwriteContextPropertyIfExists}
                    shouldSuffixContextPropertyIfSplitIsUsed = {this.state.shouldSuffixContextPropertyIfSplitIsUsed}
                    updateProperty={this.updateProperty}
                    elementIdAutoIncrement={this.state.elementIdAutoIncrement}
                />
            </PanelLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {hideModal, clickedNodeAction})(ContextUpdaterPanel);